import { useFormContext } from "react-hook-form";

import FormInput from "@/components/form-fields/form-input";
import { AsyncSingleSelect } from "@/components/reusables/async-select/async-single-select";
import DateInput from "@/components/reusables/custom-form-fields/DateInput";
import { ICustomer } from "@/interfaces/customer.interface";
import { customerUser } from "@/interfaces/interfaces";
import { useGetAllCustomerByWSQuery } from "@/redux/api/clientQuery";
import { TAddProjectSchema } from "@/schemas/project.schema";

const ProjectBasicInfo = (): React.ReactElement => {
  const form = useFormContext<TAddProjectSchema>();

  return (
    <>
      <h2 className='col-span-3 text-lg font-medium'>Projects Details</h2>
      <FormInput
        form={form}
        name='projectName'
        label='Project Name'
        required
        charLimit={300}
        input={{
          placeholder: "Enter Project Name",
        }}
      />
      <FormInput
        name='customerId'
        form={form}
        label='Customer'
        required
        render={(field) => (
          <AsyncSingleSelect<
            ICustomer | customerUser,
            { user: string; status: string; filter?: string }
          >
            useQuery={useGetAllCustomerByWSQuery}
            baseParams={{ user: "", status: "ACTIVE" }}
            renderConfig={{
              valueKey: "id",
              labelKey: "name",
            }}
            defaultLabel={form.getValues("customerDefaultName")}
            placeholder='Select Customer'
            value={field.value}
            onChange={(value) => {
              field.onChange(value);
              form.setValue("customerProjectTeam", [], {
                shouldDirty: true,
              });
            }}
            label='Customers'
            limit={10}
          />
        )}
      />

      <div className='flex flex-col gap-2'>
        <FormInput
          name='startDate'
          form={form}
          label='Start Date'
          required
          render={(field) => {
            return (
              <DateInput
                defaultValue={field.value as unknown as Date | undefined}
                onChange={(date) => field.onChange(date)}
                dateLimit={new Date(new Date().getTime() - 24 * 60 * 60 * 1000)}
              />
            );
          }}
        />
      </div>
    </>
  );
};

export default ProjectBasicInfo;
